import React from 'react';
import { Award, Star, HandHeart } from 'lucide-react';
import { business } from '../mock';

const items = [
  {
    icon: Award,
    title: `Proudly Serving DFW Since ${business.since}`,
    desc: '15+ years of trusted, dignified in-home care',
  },
  {
    icon: Star,
    title: '5-Star Rated on Google & Facebook',
    desc: `Loved by ${business.familiesServed} families across Dallas–Fort Worth`,
  },
  {
    icon: HandHeart,
    title: 'Free In-Home Consultation',
    desc: 'No cost, no obligation — always',
  },
];

export default function TrustStrip() {
  return (
    <section className="pt-16 pb-4">
      <div className="container-x">
        <div className="grid md:grid-cols-3 gap-5">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={i}
                className="reveal flex items-center gap-4 px-6 py-6 rounded-3xl bg-white transition-all duration-300 hover:-translate-y-1"
                style={{ border: '1px solid var(--line)', boxShadow: '0 10px 30px -22px rgba(30,59,44,0.5)' }}
              >
                <span
                  className="flex items-center justify-center rounded-2xl shrink-0"
                  style={{ width: 58, height: 58, backgroundColor: 'var(--sage)' }}
                >
                  <Icon size={28} style={{ color: 'var(--forest)' }} strokeWidth={1.8} />
                </span>
                <div>
                  <div className="font-serif-display text-[19px] leading-tight" style={{ color: 'var(--forest)' }}>
                    {it.title}
                  </div>
                  <div className="text-sm mt-1" style={{ color: 'var(--muted)' }}>{it.desc}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
